function $45ffa6ee91549f09$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $45ffa6ee91549f09$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $45ffa6ee91549f09$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $45ffa6ee91549f09$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $45ffa6ee91549f09$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $45ffa6ee91549f09$var$normalizeComputedStyleValue(string) {
    // "250px" --> 250
    return +string.replace(/px/, '');
}
function $45ffa6ee91549f09$var$fixDPR(canvas) {
    var dpr = window.devicePixelRatio;
    var computedStyles = getComputedStyle(canvas);
    var width = $45ffa6ee91549f09$var$normalizeComputedStyleValue(computedStyles.getPropertyValue('width'));
    var height = $45ffa6ee91549f09$var$normalizeComputedStyleValue(computedStyles.getPropertyValue('height'));
    canvas.setAttribute('width', (width * dpr).toString());
    canvas.setAttribute('height', (height * dpr).toString());
}
function $45ffa6ee91549f09$var$generateRandomNumber(min, max) {
    var fractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var randomNumber = Math.random() * (max - min) + min;
    return Math.floor(randomNumber * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);
}
function $45ffa6ee91549f09$var$generateRandomArrayElement(arr) {
    return arr[$45ffa6ee91549f09$var$generateRandomNumber(0, arr.length)];
}
var $45ffa6ee91549f09$var$FREE_FALLING_OBJECT_ACCELERATION = 0.00125;
var $45ffa6ee91549f09$var$MIN_DRAG_FORCE_COEFFICIENT = 0.0005;
var $45ffa6ee91549f09$var$MAX_DRAG_FORCE_COEFFICIENT = 0.0009;
var $45ffa6ee91549f09$var$ROTATION_SLOWDOWN_ACCELERATION = 0.00001;
var $45ffa6ee91549f09$var$INITIAL_SHAPE_RADIUS = 6;
var $45ffa6ee91549f09$var$INITIAL_EMOJI_SIZE = 80;
var $45ffa6ee91549f09$var$MIN_INITIAL_CONFETTI_SPEED = 0.9;
var $45ffa6ee91549f09$var$MAX_INITIAL_CONFETTI_SPEED = 1.7;
var $45ffa6ee91549f09$var$MIN_FINAL_X_CONFETTI_SPEED = 0.2;
var $45ffa6ee91549f09$var$MAX_FINAL_X_CONFETTI_SPEED = 0.6;
var $45ffa6ee91549f09$var$MIN_INITIAL_ROTATION_SPEED = 0.03;
var $45ffa6ee91549f09$var$MAX_INITIAL_ROTATION_SPEED = 0.07;
var $45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE = 15;
var $45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE = 82;
var $45ffa6ee91549f09$var$MAX_CONFETTI_POSITION_SHIFT = 150;
var $45ffa6ee91549f09$var$SHAPE_VISIBILITY_TRESHOLD = 100;
var $45ffa6ee91549f09$var$DEFAULT_CONFETTI_NUMBER = 250;
var $45ffa6ee91549f09$var$DEFAULT_EMOJIS_NUMBER = 40;
var $45ffa6ee91549f09$var$DEFAULT_CONFETTI_COLORS = [
    '#fcf403',
    '#62fc03',
    '#f4fc03',
    '#03e7fc',
    '#03fca5',
    '#a503fc',
    '#fc03ad',
    '#fc03c2'
];
function $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth) {
    var HD_SCREEN_WIDTH = 1920;
    return Math.log(canvasWidth) / Math.log(HD_SCREEN_WIDTH);
}
var $45ffa6ee91549f09$var$ConfettiShape = /*#__PURE__*/ function() {
    function ConfettiShape(args) {
        $45ffa6ee91549f09$var$_classCallCheck(this, ConfettiShape);
        var initialPosition = args.initialPosition, direction = args.direction, confettiRadius = args.confettiRadius, confettiColors = args.confettiColors, emojis = args.emojis, emojiSize = args.emojiSize, canvasWidth = args.canvasWidth;
        var randomConfettiSpeed = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_INITIAL_CONFETTI_SPEED, $45ffa6ee91549f09$var$MAX_INITIAL_CONFETTI_SPEED, 3);
        var initialSpeed = randomConfettiSpeed * $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth);
        this.confettiSpeed = {
            x: initialSpeed,
            y: initialSpeed
        };
        this.finalConfettiSpeedX = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_FINAL_X_CONFETTI_SPEED, $45ffa6ee91549f09$var$MAX_FINAL_X_CONFETTI_SPEED, 3);
        this.rotationSpeed = emojis.length ? 0.01 : $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_INITIAL_ROTATION_SPEED, $45ffa6ee91549f09$var$MAX_INITIAL_ROTATION_SPEED, 3) * $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth);
        this.dragForceCoefficient = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_DRAG_FORCE_COEFFICIENT, $45ffa6ee91549f09$var$MAX_DRAG_FORCE_COEFFICIENT, 6);
        this.radius = {
            x: confettiRadius,
            y: confettiRadius
        };
        this.initialRadius = confettiRadius;
        this.rotationAngle = direction === 'left' ? $45ffa6ee91549f09$var$generateRandomNumber(0, 0.2, 3) : $45ffa6ee91549f09$var$generateRandomNumber(-0.2, 0, 3);
        this.emojiSize = emojiSize;
        this.emojiRotationAngle = $45ffa6ee91549f09$var$generateRandomNumber(0, 2 * Math.PI);
        this.radiusYUpdateDirection = 'down';
        var angle = direction === 'left' ? $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE, $45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE) * Math.PI / 180 : $45ffa6ee91549f09$var$generateRandomNumber(-$45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE, -$45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE) * Math.PI / 180;
        this.absCos = Math.abs(Math.cos(angle));
        this.absSin = Math.abs(Math.sin(angle));
        var positionShift = $45ffa6ee91549f09$var$generateRandomNumber(-$45ffa6ee91549f09$var$MAX_CONFETTI_POSITION_SHIFT, 0);
        var shiftedInitialPosition = {
            x: initialPosition.x + (direction === 'left' ? -positionShift : positionShift) * this.absCos,
            y: initialPosition.y - positionShift * this.absSin
        };
        this.currentPosition = Object.assign({}, shiftedInitialPosition);
        this.initialPosition = Object.assign({}, shiftedInitialPosition);
        this.color = emojis.length ? null : $45ffa6ee91549f09$var$generateRandomArrayElement(confettiColors);
        this.emoji = emojis.length ? $45ffa6ee91549f09$var$generateRandomArrayElement(emojis) : null;
        this.createdAt = new Date().getTime();
        this.direction = direction;
    }
    $45ffa6ee91549f09$var$_createClass(ConfettiShape, [
        {
            key: "draw",
            value: function draw(canvasContext) {
                var currentPosition = this.currentPosition, radius = this.radius, color = this.color, emoji = this.emoji, rotationAngle = this.rotationAngle, emojiRotationAngle = this.emojiRotationAngle, emojiSize = this.emojiSize;
                var dpr = window.devicePixelRatio;
                if (color) {
                    canvasContext.fillStyle = color;
                    canvasContext.beginPath();
                    canvasContext.ellipse(currentPosition.x * dpr, currentPosition.y * dpr, radius.x * dpr, radius.y * dpr, rotationAngle, 0, 2 * Math.PI);
                    canvasContext.fill();
                } else if (emoji) {
                    canvasContext.font = "".concat(emojiSize, "px serif");
                    canvasContext.save();
                    canvasContext.translate(dpr * currentPosition.x, dpr * currentPosition.y);
                    canvasContext.rotate(emojiRotationAngle);
                    canvasContext.textAlign = 'center';
                    canvasContext.fillText(emoji, 0, 0);
                    canvasContext.restore();
                }
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(iterationTimeDelta, currentTime) {
                var confettiSpeed = this.confettiSpeed, dragForceCoefficient = this.dragForceCoefficient, finalConfettiSpeedX = this.finalConfettiSpeedX, radiusYUpdateDirection = this.radiusYUpdateDirection, rotationSpeed = this.rotationSpeed, createdAt = this.createdAt, direction = this.direction;
                var timeDeltaSinceCreation = currentTime - createdAt;
                if (confettiSpeed.x > finalConfettiSpeedX) this.confettiSpeed.x -= dragForceCoefficient * iterationTimeDelta;
                this.currentPosition.x += confettiSpeed.x * (direction === 'left' ? -this.absCos : this.absCos) * iterationTimeDelta;
                this.currentPosition.y = this.initialPosition.y - confettiSpeed.y * this.absSin * timeDeltaSinceCreation + $45ffa6ee91549f09$var$FREE_FALLING_OBJECT_ACCELERATION * Math.pow(timeDeltaSinceCreation, 2) / 2;
                this.rotationSpeed -= this.emoji ? 0.0001 : $45ffa6ee91549f09$var$ROTATION_SLOWDOWN_ACCELERATION * iterationTimeDelta;
                if (this.rotationSpeed < 0) this.rotationSpeed = 0; // no need to update rotation radius for emoji
                if (this.emoji) {
                    this.emojiRotationAngle += this.rotationSpeed * iterationTimeDelta % (2 * Math.PI);
                    return;
                }
                if (radiusYUpdateDirection === 'down') {
                    this.radius.y -= iterationTimeDelta * rotationSpeed;
                    if (this.radius.y <= 0) {
                        this.radius.y = 0;
                        this.radiusYUpdateDirection = 'up';
                    }
                } else {
                    this.radius.y += iterationTimeDelta * rotationSpeed;
                    if (this.radius.y >= this.initialRadius) {
                        this.radius.y = this.initialRadius;
                        this.radiusYUpdateDirection = 'down';
                    }
                }
            }
        },
        {
            key: "getIsVisibleOnCanvas",
            value: function getIsVisibleOnCanvas(canvasHeight) {
                return this.currentPosition.y < canvasHeight + $45ffa6ee91549f09$var$SHAPE_VISIBILITY_TRESHOLD;
            }
        }
    ]);
    return ConfettiShape;
}();
function $45ffa6ee91549f09$var$createCanvas() {
    var canvas = document.createElement('canvas');
    canvas.style.position = 'fixed';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.zIndex = '1000';
    canvas.style.pointerEvents = 'none';
    document.body.appendChild(canvas);
    return canvas;
}
function $45ffa6ee91549f09$var$normalizeConfettiConfig(confettiConfig) {
    var _confettiConfig$confe = confettiConfig.confettiRadius, confettiRadius = _confettiConfig$confe === void 0 ? $45ffa6ee91549f09$var$INITIAL_SHAPE_RADIUS : _confettiConfig$confe, _confettiConfig$confe2 = confettiConfig.confettiNumber, confettiNumber = _confettiConfig$confe2 === void 0 ? confettiConfig.confettiesNumber || (confettiConfig.emojis ? $45ffa6ee91549f09$var$DEFAULT_EMOJIS_NUMBER : $45ffa6ee91549f09$var$DEFAULT_CONFETTI_NUMBER) : _confettiConfig$confe2, _confettiConfig$confe3 = confettiConfig.confettiColors, confettiColors = _confettiConfig$confe3 === void 0 ? $45ffa6ee91549f09$var$DEFAULT_CONFETTI_COLORS : _confettiConfig$confe3, _confettiConfig$emoji = confettiConfig.emojis, emojis = _confettiConfig$emoji === void 0 ? confettiConfig.emojies || [] : _confettiConfig$emoji, _confettiConfig$emoji2 = confettiConfig.emojiSize, emojiSize = _confettiConfig$emoji2 === void 0 ? $45ffa6ee91549f09$var$INITIAL_EMOJI_SIZE : _confettiConfig$emoji2; // deprecate wrong plural forms, used in early releases
    if (confettiConfig.emojies) console.error("emojies argument is deprecated, please use emojis instead");
    if (confettiConfig.confettiesNumber) console.error("confettiesNumber argument is deprecated, please use confettiNumber instead");
    return {
        confettiRadius: confettiRadius,
        confettiNumber: confettiNumber,
        confettiColors: confettiColors,
        emojis: emojis,
        emojiSize: emojiSize
    };
}
var $45ffa6ee91549f09$var$ConfettiBatch = /*#__PURE__*/ function() {
    function ConfettiBatch(canvasContext) {
        var _this = this;
        $45ffa6ee91549f09$var$_classCallCheck(this, ConfettiBatch);
        this.canvasContext = canvasContext;
        this.shapes = [];
        this.promise = new Promise(function(completionCallback) {
            return _this.resolvePromise = completionCallback;
        });
    }
    $45ffa6ee91549f09$var$_createClass(ConfettiBatch, [
        {
            key: "getBatchCompletePromise",
            value: function getBatchCompletePromise() {
                return this.promise;
            }
        },
        {
            key: "addShapes",
            value: function addShapes() {
                var _this$shapes;
                (_this$shapes = this.shapes).push.apply(_this$shapes, arguments);
            }
        },
        {
            key: "complete",
            value: function complete() {
                var _a;
                if (this.shapes.length) return false;
                (_a = this.resolvePromise) === null || _a === void 0 || _a.call(this);
                return true;
            }
        },
        {
            key: "processShapes",
            value: function processShapes(time, canvasHeight, cleanupInvisibleShapes) {
                var _this2 = this;
                var timeDelta = time.timeDelta, currentTime = time.currentTime;
                this.shapes = this.shapes.filter(function(shape) {
                    // Render the shapes in this batch
                    shape.updatePosition(timeDelta, currentTime);
                    shape.draw(_this2.canvasContext); // Only cleanup the shapes if we're being asked to
                    if (!cleanupInvisibleShapes) return true;
                    return shape.getIsVisibleOnCanvas(canvasHeight);
                });
            }
        }
    ]);
    return ConfettiBatch;
}();
var $45ffa6ee91549f09$var$JSConfetti = /*#__PURE__*/ function() {
    function JSConfetti() {
        var jsConfettiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $45ffa6ee91549f09$var$_classCallCheck(this, JSConfetti);
        this.activeConfettiBatches = [];
        this.canvas = jsConfettiConfig.canvas || $45ffa6ee91549f09$var$createCanvas();
        this.canvasContext = this.canvas.getContext('2d');
        this.requestAnimationFrameRequested = false;
        this.lastUpdated = new Date().getTime();
        this.iterationIndex = 0;
        this.loop = this.loop.bind(this);
        requestAnimationFrame(this.loop);
    }
    $45ffa6ee91549f09$var$_createClass(JSConfetti, [
        {
            key: "loop",
            value: function loop() {
                this.requestAnimationFrameRequested = false;
                $45ffa6ee91549f09$var$fixDPR(this.canvas);
                var currentTime = new Date().getTime();
                var timeDelta = currentTime - this.lastUpdated;
                var canvasHeight = this.canvas.offsetHeight;
                var cleanupInvisibleShapes = this.iterationIndex % 10 === 0;
                this.activeConfettiBatches = this.activeConfettiBatches.filter(function(batch) {
                    batch.processShapes({
                        timeDelta: timeDelta,
                        currentTime: currentTime
                    }, canvasHeight, cleanupInvisibleShapes); // Do not remove invisible shapes on every iteration
                    if (!cleanupInvisibleShapes) return true;
                    return !batch.complete();
                });
                this.iterationIndex++;
                this.queueAnimationFrameIfNeeded(currentTime);
            }
        },
        {
            key: "queueAnimationFrameIfNeeded",
            value: function queueAnimationFrameIfNeeded(currentTime) {
                if (this.requestAnimationFrameRequested) // We already have a pended animation frame, so there is no more work
                return;
                if (this.activeConfettiBatches.length < 1) // No shapes to animate, so don't queue another frame
                return;
                this.requestAnimationFrameRequested = true; // Capture the last updated time for animation
                this.lastUpdated = currentTime || new Date().getTime();
                requestAnimationFrame(this.loop);
            }
        },
        {
            key: "addConfetti",
            value: function addConfetti() {
                var confettiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _normalizeConfettiCon = $45ffa6ee91549f09$var$normalizeConfettiConfig(confettiConfig), confettiRadius = _normalizeConfettiCon.confettiRadius, confettiNumber = _normalizeConfettiCon.confettiNumber, confettiColors = _normalizeConfettiCon.confettiColors, emojis = _normalizeConfettiCon.emojis, emojiSize = _normalizeConfettiCon.emojiSize; // Use the bounding rect rather tahn the canvas width / height, because
                // .width / .height are unset until a layout pass has been completed. Upon
                // confetti being immediately queued on a page load, this hasn't happened so
                // the default of 300x150 will be returned, causing an improper source point
                // for the confetti animation.
                var canvasRect = this.canvas.getBoundingClientRect();
                var canvasWidth = canvasRect.width;
                var canvasHeight = canvasRect.height;
                var yPosition = canvasHeight * 5 / 7;
                var leftConfettiPosition = {
                    x: 0,
                    y: yPosition
                };
                var rightConfettiPosition = {
                    x: canvasWidth,
                    y: yPosition
                };
                var confettiGroup = new $45ffa6ee91549f09$var$ConfettiBatch(this.canvasContext);
                for(var i = 0; i < confettiNumber / 2; i++){
                    var confettiOnTheRight = new $45ffa6ee91549f09$var$ConfettiShape({
                        initialPosition: leftConfettiPosition,
                        direction: 'right',
                        confettiRadius: confettiRadius,
                        confettiColors: confettiColors,
                        confettiNumber: confettiNumber,
                        emojis: emojis,
                        emojiSize: emojiSize,
                        canvasWidth: canvasWidth
                    });
                    var confettiOnTheLeft = new $45ffa6ee91549f09$var$ConfettiShape({
                        initialPosition: rightConfettiPosition,
                        direction: 'left',
                        confettiRadius: confettiRadius,
                        confettiColors: confettiColors,
                        confettiNumber: confettiNumber,
                        emojis: emojis,
                        emojiSize: emojiSize,
                        canvasWidth: canvasWidth
                    });
                    confettiGroup.addShapes(confettiOnTheRight, confettiOnTheLeft);
                }
                this.activeConfettiBatches.push(confettiGroup);
                this.queueAnimationFrameIfNeeded();
                return confettiGroup.getBatchCompletePromise();
            }
        },
        {
            key: "clearCanvas",
            value: function clearCanvas() {
                this.activeConfettiBatches = [];
            }
        }
    ]);
    return JSConfetti;
}();
var $45ffa6ee91549f09$export$2e2bcd8739ae039 = $45ffa6ee91549f09$var$JSConfetti;


const $b770ca7c578c66ca$var$playback = document.getElementById("playback");
const $b770ca7c578c66ca$var$skip = document.getElementById("skip");
const $b770ca7c578c66ca$var$heart = document.getElementById("heart");
const $b770ca7c578c66ca$var$label = document.getElementById("label");
const $b770ca7c578c66ca$var$input = document.getElementById("input");
const $b770ca7c578c66ca$var$range = document.getElementById("range");
const $b770ca7c578c66ca$var$voice = document.getElementById("voice");
const $b770ca7c578c66ca$var$audio = document.getElementById("audio");
let $b770ca7c578c66ca$var$startTime;
let $b770ca7c578c66ca$var$number;
let $b770ca7c578c66ca$var$streak = 0;
let $b770ca7c578c66ca$var$love = false;
let $b770ca7c578c66ca$var$largest;
let $b770ca7c578c66ca$var$voiceLanguage;
$b770ca7c578c66ca$var$setVoice();
$b770ca7c578c66ca$var$setLargest();
$b770ca7c578c66ca$var$setStyle();
$b770ca7c578c66ca$var$changeStats();
$b770ca7c578c66ca$var$newNumber();
const $b770ca7c578c66ca$var$jsConfetti = new (0, $45ffa6ee91549f09$export$2e2bcd8739ae039)();
// ### Core ###
// @ts-ignore
async function $b770ca7c578c66ca$var$newNumber() {
    $b770ca7c578c66ca$var$number = Math.round(Math.random() * $b770ca7c578c66ca$var$largest);
    console.log("Fetching audio for number:", $b770ca7c578c66ca$var$number);
    await $b770ca7c578c66ca$var$fetchSynthesis();
    $b770ca7c578c66ca$var$startTime = new Date().getTime();
}
// @ts-ignore
async function $b770ca7c578c66ca$var$fetchSynthesis() {
    const endpoint = window.location.host === "localhost:1234" ? "http://localhost:8080" : "";
    const response = await fetch(endpoint + "/synthesize", {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'omit',
        headers: {
            'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify({
            text: $b770ca7c578c66ca$var$number.toString(),
            languageCode: $b770ca7c578c66ca$var$voiceLanguage
        }) // body data type must match "Content-Type" header
    });
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    $b770ca7c578c66ca$var$audio.src = objectUrl;
    // Release resource when it's loaded
    $b770ca7c578c66ca$var$audio.onload = function() {
        URL.revokeObjectURL(objectUrl);
    };
}
// ### Helper ###
function $b770ca7c578c66ca$var$playNumber() {
    $b770ca7c578c66ca$var$audio.play();
}
function $b770ca7c578c66ca$var$setStyle() {
    const min = Number($b770ca7c578c66ca$var$range.min);
    const max = Number($b770ca7c578c66ca$var$range.max);
    const val = Number($b770ca7c578c66ca$var$range.value);
    $b770ca7c578c66ca$var$range.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
}
function $b770ca7c578c66ca$var$runConfetti() {
    if ($b770ca7c578c66ca$var$love) $b770ca7c578c66ca$var$jsConfetti.addConfetti({
        emojis: [
            "\u2764\uFE0F"
        ],
        emojiSize: 100,
        //confettiRadius: 100,
        confettiNumber: 50
    });
    else $b770ca7c578c66ca$var$jsConfetti.addConfetti();
}
// ### Settings ###
function $b770ca7c578c66ca$var$setLargest() {
    switch($b770ca7c578c66ca$var$range.value){
        case "0":
            $b770ca7c578c66ca$var$largest = 10;
            break;
        case "1":
            $b770ca7c578c66ca$var$largest = 100;
            break;
        case "2":
            $b770ca7c578c66ca$var$largest = 1000;
            break;
        case "3":
            $b770ca7c578c66ca$var$largest = 1000000;
            break;
    }
}
function $b770ca7c578c66ca$var$setVoice() {
    $b770ca7c578c66ca$var$voiceLanguage = $b770ca7c578c66ca$var$voice.value;
}
// ### Stats ###
function $b770ca7c578c66ca$var$getKey(name) {
    return $b770ca7c578c66ca$var$voiceLanguage + "." + name;
}
function $b770ca7c578c66ca$var$getStorage(name) {
    return localStorage.getItem($b770ca7c578c66ca$var$getKey(name));
}
function $b770ca7c578c66ca$var$changeStats() {
    const statsTitle = document.querySelector("section.stats p");
    statsTitle.setAttribute("data-dict", "stats.title." + $b770ca7c578c66ca$var$voiceLanguage);
    document.querySelectorAll('[data-stats]').forEach((element)=>{
        const value = $b770ca7c578c66ca$var$getStorage(element.getAttribute("data-stats"));
        element.innerHTML = value ? value : "-";
    });
}
function $b770ca7c578c66ca$var$updateStat(name, value) {
    localStorage.setItem($b770ca7c578c66ca$var$getKey(name), value);
    document.querySelector('[data-stats="' + name + '"]').innerHTML = value;
}
function $b770ca7c578c66ca$var$incrementStat(name) {
    let number = parseInt($b770ca7c578c66ca$var$getStorage(name));
    number = number ? number + 1 : 1;
    $b770ca7c578c66ca$var$updateStat(name, number.toString());
}
function $b770ca7c578c66ca$var$lowerStat(name, value) {
    let number = parseInt($b770ca7c578c66ca$var$getStorage(name));
    if (isNaN(number) || value < number) $b770ca7c578c66ca$var$updateStat(name, value.toString());
}
function $b770ca7c578c66ca$var$riseStat(name, value) {
    let number = parseInt($b770ca7c578c66ca$var$getStorage(name));
    if (isNaN(number) || value > number) $b770ca7c578c66ca$var$updateStat(name, value.toString());
}
// ### Events ###
$b770ca7c578c66ca$var$playback.onclick = ()=>{
    $b770ca7c578c66ca$var$playNumber();
};
$b770ca7c578c66ca$var$skip.onclick = ()=>{
    $b770ca7c578c66ca$var$streak = 0;
    $b770ca7c578c66ca$var$newNumber().then(()=>{
        $b770ca7c578c66ca$var$playNumber();
    });
};
$b770ca7c578c66ca$var$input.oninput = ()=>{
    if (isNaN(+$b770ca7c578c66ca$var$input.value)) return;
    if (Number($b770ca7c578c66ca$var$input.value) === $b770ca7c578c66ca$var$number) {
        const duration = (new Date().getTime() - $b770ca7c578c66ca$var$startTime) / 1000;
        $b770ca7c578c66ca$var$input.value = "";
        $b770ca7c578c66ca$var$streak += 1;
        $b770ca7c578c66ca$var$riseStat("solved.streak", $b770ca7c578c66ca$var$streak);
        $b770ca7c578c66ca$var$riseStat("solved.highest", $b770ca7c578c66ca$var$number);
        $b770ca7c578c66ca$var$lowerStat("solved.quickest", duration);
        $b770ca7c578c66ca$var$incrementStat("solved.total");
        if ($b770ca7c578c66ca$var$number <= 10) $b770ca7c578c66ca$var$incrementStat("solved.10");
        else if ($b770ca7c578c66ca$var$number <= 100) $b770ca7c578c66ca$var$incrementStat("solved.100");
        else if ($b770ca7c578c66ca$var$number <= 1000) $b770ca7c578c66ca$var$incrementStat("solved.1000");
        else if ($b770ca7c578c66ca$var$number <= 1000000) $b770ca7c578c66ca$var$incrementStat("solved.1000000");
        if ($b770ca7c578c66ca$var$streak % 5 === 0) $b770ca7c578c66ca$var$runConfetti();
        $b770ca7c578c66ca$var$newNumber().then(()=>{
            $b770ca7c578c66ca$var$playNumber();
        });
    }
};
$b770ca7c578c66ca$var$input.onfocus = ()=>{
    $b770ca7c578c66ca$var$label.style.opacity = "0";
};
$b770ca7c578c66ca$var$input.onblur = ()=>{
    if ($b770ca7c578c66ca$var$input.value != "") return;
    $b770ca7c578c66ca$var$label.style.opacity = "1";
};
$b770ca7c578c66ca$var$range.oninput = ()=>{
    $b770ca7c578c66ca$var$setStyle();
    $b770ca7c578c66ca$var$setLargest();
    $b770ca7c578c66ca$var$newNumber().then(()=>{
        $b770ca7c578c66ca$var$playNumber();
    });
};
$b770ca7c578c66ca$var$voice.oninput = ()=>{
    $b770ca7c578c66ca$var$setVoice();
    $b770ca7c578c66ca$var$changeStats();
    $b770ca7c578c66ca$var$newNumber().then(()=>{
        $b770ca7c578c66ca$var$playNumber();
    });
};
$b770ca7c578c66ca$var$heart.onclick = ()=>{
    $b770ca7c578c66ca$var$love = true;
    $b770ca7c578c66ca$var$runConfetti();
};


//# sourceMappingURL=app.6de32394.js.map
